import { tryCatch } from '../tryCatch';
export const parseSafeJSON = tryCatch(v => JSON.parse(v), v => v);